import apiFetch from '../../apiFetch'

export default function (dossierId = null, token) {
  return apiFetch({ endPoint: `Dossier/Sale/${dossierId}/SendChargeToDms`, method: 'PUT', body: null, token: token, lastAccessDate: 'ref' })
}
